import { render, staticRenderFns } from "./income-history-information.vue?vue&type=template&id=ad502224&scoped=true"
import script from "./income-history-information.vue?vue&type=script&lang=ts"
export * from "./income-history-information.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad502224",
  null
  
)

export default component.exports